<template>
  <div class="">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formSearch" class="demo-form-inline">
        
        <el-form-item label="类型筛选">
          <el-button-group>
            <el-button @click="changeTypeFunc('')">不限</el-button>
            <el-button :type="formSearch.type == item.form_id ? 'primary' : ''" plain v-for="(item, index) in type" :key="index" @click="changeTypeFunc(item.form_id)">{{item.name}}</el-button>
          </el-button-group>
        </el-form-item>
        <el-form-item label="字段使用说明：">
          <p class="gray9">【择校】详情、对比、基础搜索、高级搜索、导入(表格导入顺序按排序从小到大，<span class="gray3">如果排序有变，导入表格文档要调整</span>); 【拟排名】详情(结果排名页)</p>
        </el-form-item>
        <br>

        <el-form-item label="名称">
          <el-input v-model="formSearch.name" placeholder="请输入名称" clearable></el-input>
        </el-form-item>

        <template v-if="formSearch.type==1">
        <el-form-item label="显示详情">
          <el-select v-model="formSearch.is_detail" clearable placeholder="请选择" style="width:80px">
            <el-option label="不限" value=""></el-option>
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="显示对比">
          <el-select v-model="formSearch.is_contrast" clearable placeholder="请选择" style="width:80px" >
            <el-option label="不限" value=""></el-option>
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="基础搜索">
          <el-select v-model="formSearch.is_basics_search" clearable placeholder="请选择" style="width:80px" >
            <el-option label="不限" value=""></el-option>
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="高级搜索">
          <el-select v-model="formSearch.is_advanced_search" clearable placeholder="请选择" style="width:80px" >
            <el-option label="不限" value=""></el-option>
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="择校导入">
          <el-select v-model="formSearch.is_import" clearable placeholder="请选择" style="width:80px">
            <el-option label="不限" value=""></el-option>
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>
        </template>

        <el-form-item label="状态">
          <el-select v-model="formSearch.status" clearable placeholder="请选择" style="width:80px">
            <el-option label="不限" value=""></el-option>
            <el-option label="显示" value="1"></el-option>
            <el-option label="隐藏" value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="答案类型">
          <el-select v-model="formSearch.input_type" clearable placeholder="请选择">
            <el-option label="不限" value=""></el-option>
            <el-option :label="v.text" :value="v.value" v-for="(v, i) in input_type" :key="i"></el-option>
          </el-select>
        </el-form-item>

        <!-- <el-form-item label="起始日期">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="formSearch.create_time" clearable type="daterange"  value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div>
      <el-button size="small" type="primary" @click="openPopup('add')" icon="el-icon-plus">添加</el-button>
      <el-button size="small" type="primary" @click="openPopup('batch')" icon="el-icon-check">批量操作</el-button>
    </div>

    <!--内容-->
    <div class="content mt10">
      <div class="table-wrap">
        <el-table size="small" ref="table" :data="tableData" border style="width: 100%" v-loading="loading" @sort-change="sortChange" :row-key="getRowKey"  @selection-change="tableCurrentChange">
          <el-table-column type="selection" :reserve-selection="true" align="center" width="45"></el-table-column>
          <el-table-column prop="field_id" label="ID" width="80" sortable="custom" align="center"></el-table-column>
          <el-table-column prop="sort" label="排序" sortable="custom" align="center" width="80"></el-table-column>
          <el-table-column prop="type" label="类型" width="100">
            <template slot-scope="scope">
              {{ type[scope.row.type].name }}
            </template>
          </el-table-column>
          <el-table-column prop="name" label="名称"></el-table-column>
          <el-table-column prop="key_name" label="键值" width="160"></el-table-column>
          <el-table-column prop="type_info" label="答案类型" width="150"></el-table-column>
          <el-table-column prop="input_values" label="参数" width="150">
            <template slot-scope="scope">
              <p v-for="(v, i) in scope.row.input_values" :key="i">
                <span v-if="scope.row.input_type == 3 || scope.row.input_type == 4">{{ v.value+'='+v.text }}</span>
              </p>
            </template>
          </el-table-column>
          <el-table-column prop="required" label="必填" width="60" align="center" v-if="formSearch.type==2 || formSearch.type==3">
            <template slot-scope="scope">
              <span class="red" v-if="scope.row.required == 1">是</span>
              <span class="gray9" v-else>-</span>
            </template>
          </el-table-column>

          <template v-if="formSearch.type==1">
            <el-table-column prop="is_detail" label="是否显示在详情" width="60" align="center">
              <template slot-scope="scope">
                <span class="green" v-if="scope.row.is_detail == 1">是</span>
                <span class="gray9" v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="is_contrast" label="是否显示在对比" width="60" align="center">
              <template slot-scope="scope">
                <span class="green" v-if="scope.row.is_contrast == 1">是</span>
                <span class="gray9" v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="is_basics_search" label="基础搜索" width="60" align="center">
              <template slot-scope="scope">
                <span class="green" v-if="scope.row.is_basics_search == 1">是</span>
                <span class="gray9" v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="is_advanced_search" label="高级搜索" width="60" align="center">
              <template slot-scope="scope">
                <span class="green" v-if="scope.row.is_advanced_search == 1">是</span>
                <span class="gray9" v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="is_import" label="择校导入字段" width="60" align="center">
              <template slot-scope="scope">
                <span class="green" v-if="scope.row.is_import == 1">是</span>
                <span class="gray9" v-else>-</span>
              </template>
            </el-table-column>
          </template>

          <el-table-column prop="is_hidden" label="默认隐藏" width="60" align="center" v-if="formSearch.type==3">
            <template slot-scope="scope">
              <span class="green" v-if="scope.row.is_hidden == 1">是</span>
              <span class="gray9" v-else>-</span>
            </template>
          </el-table-column>

          <el-table-column prop="status" label="状态" width="60" align="center">
            <template slot-scope="scope">
              <span class="green" v-if="scope.row.status == 1">显示</span>
              <span class="gray9" v-else>隐藏</span>
            </template>
          </el-table-column>
          
          <el-table-column prop="name" label="操作" width="160" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button @click="openPopup('edit', scope.row)" type="text" size="small">编辑</el-button>
              <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-sizes="[20, 50, 100, 200, 300, 500]"
          :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>

    <!--添加-->
    <Add v-if="show_popup['add']" :open_add="show_popup['add']" :selectModel="formSearch" :type="type" :input_type="input_type" @closeDialog="closeDialogFunc($event, 'add')"></Add>

    <!--编辑-->
    <Edit v-if="show_popup['edit']" :open_edit="show_popup['edit']" :formSearch="formSearch" :type="type" :input_type="input_type" :selectModel="selectModel" @closeDialog="closeDialogFunc($event, 'edit')"></Edit>

    <!--批量-->
    <Batch v-if="show_popup['batch']" :is_open="show_popup['batch']" :ids="ids" @closeDialog="closeDialogFunc($event, 'batch')"></Batch>
  </div>
</template>
<script>
  import CustomFieldApi from '@/api/study/custom_field.js';
  import Edit from './part/Edit.vue';
  import Add from './part/Add';
  import Batch from './part/Batch';
  import qs from 'qs';
  export default {
    components: {
      Add,
      Edit,
      Batch
    },
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formSearch: {
          type: '',
          name: '',
          input_type: '',
          status: '',
          is_detail: '',
          is_contrast: '',
          is_basics_search: '',
          is_advanced_search: '',
          is_import: '',
          create_time: '',
        },
        /*弹窗*/
        show_popup: {
          add: false,
          edit: false,
          batch: false,
        },
        /*选中的对象*/
        selectModel:{},
        input_type:[],
        multipleSelection: [],
        ids: [],
        type: [],
      };
    },
    created() {
      const params = this.$route.query;
      Object.assign(this.formSearch, params);

      // 默认
      let type = this.$db.getRouteField(this, 'type');
      if (type) this.formSearch.type = type;

      /*获取列表*/
      this.getTableList();
    },
    methods: {
      // 保存选中的数据id,row-key就是要指定一个key标识这一行的数据
      getRowKey (row) {
        return row.field_id;
      },
      /*监听复选按钮选中事件*/
      tableCurrentChange(val) {
        this.multipleSelection = val;
        this.ids = [];
        val.forEach(e => {
          this.ids.push(e.field_id);
        });
      },
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formSearch;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        Params.sort_name = self.sortName;
        Params.sort_value = self.sortValue;
        CustomFieldApi.getList(Params, true).then(res => {
          let data = res.data;
          self.loading = false;
          self.tableData = data.list.data;
          self.input_type = data.input_type;
          self.type = data.category;
          self.totalDataNumber = data.list.total;
        }).catch(error => {
          self.loading = false;
        });
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('删除后不可恢复，确认删除该记录吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            self.loading = true;
            CustomFieldApi.del({field_id: row.field_id},true)
              .then(data => {
                if (data.code == 1) {
                  self.loading = false;
                  self.$message({
                    message: data.msg,
                    type: 'success'
                  });
                  self.getTableList();
                }
              })
              .catch(error => {
                self.loading = false;
              });
          })
          .catch(() => {});
      },

      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;
        let Params = self.formSearch;
        self.getTableList();
        this.ids = [];
        this.$refs.table.clearSelection();
      },

      /*排序查询*/
      sortChange(e){
        if (e.order && e.order != null){
          this.sortName = e.prop;
          this.sortValue = e.order=='ascending' ? 'asc' : 'desc';
        }else{
          this.sortName = this.sortValue = '';
        }
        this.tableData = [];
        this.getTableList();
      },

      /*打开弹窗*/
      openPopup(name, item){
        this.show_popup[name] = true;
        if (item) this.selectModel = item;
      },

      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        this.show_popup[f] = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      },

      /*选择类型*/
      changeTypeFunc(e){
        this.formSearch.type = e;
        this.$db.setRoute(this, {'type': e});
        this.getTableList();
        this.ids = [];
        this.$refs.table.clearSelection();
      },

    }
  };
</script>
<style></style>


// WEBPACK FOOTER //
// src/views/study/custom/field/index.vue